module.exports = __webpack_public_path__ + "static/img/TR.1af780e.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/userTips/TR.png
// module id = CarH
// module chunks = 1